import React from 'react'
import Topheader from './Home/topHeader/Topheader'
import Middlebar from './Home/middleBar/Middlebar'
import NavMenu from './Home/navigationBar/NavMenu'
import Footer from './Home/footer/Footer'

export default function ApplyNow() {
  return (
    <>
     <Topheader/>
     <Middlebar/>
     <NavMenu/>
     <div className='my-10 mb-20  flex items-center justify-center'>
     <iframe 
     src="https://forms.gle/gJGTCK54pcPG8aG87" 
     width="500" 
     height="1550" 
     frameborder="0" 
     marginheight="0" marginwidth="0">Loading…</iframe>
     </div>
     <Footer/>
    </>
  )
}
